export const PERIOD_FORM_NAME = 'periodForm';
export const PERIOD_ATTACHMENT_TYPE = 'periodAttachmentType';
export const PERIOD_UPLOAD_ATTACHMENT_FIELD = 'uploadAttachment';
export const PERIOD_ATTACHMENTS_LIST_FIELD = 'attachments';
